import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [isChanging, setIsChanging] = useState(false);

  // Ensure Vietnamese is set as default on component mount
  useEffect(() => {
    if (!localStorage.getItem('language')) {
      i18n.changeLanguage('vi');
      localStorage.setItem('language', 'vi');
    }
  }, [i18n]);

  const toggleLanguage = () => {
    setIsChanging(true);
    const newLanguage = i18n.language === 'en' ? 'vi' : 'en';
    i18n.changeLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
    
    // Reset animation after it completes
    setTimeout(() => {
      setIsChanging(false);
    }, 800);
  };

  const currentLanguage = i18n.language || 'vi'; // Default to Vietnamese if undefined
  const nextLanguage = currentLanguage === 'en' ? 'vi' : 'en';
  
  return (
    <div className="language-switcher">
      <button
        className={`language-toggle-btn ${isChanging ? 'changing' : ''}`}
        onClick={toggleLanguage}
        title={`${t('language.switchLanguage')} - ${nextLanguage === 'vi' ? 'Tiếng Việt' : 'English'}`}
      >
        <span className="next-flag">
          {nextLanguage === 'vi' ? '🇻🇳' : '🇺🇸'}
        </span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;